import { ColumnProps } from './TableColumn';

export default function TableColumnCell(props: ColumnProps & { row: any }) {
  const cellClasses = ['table__cell'];
  const cellContentClasses = ['table__cell__content'];
  if (props.ellipsis) cellClasses.push('table__cell--ellipsis');
  if (props.textAlign) cellClasses.push(`!text-${props.textAlign}`);
  if (props.verticalAlign) cellClasses.push(`!valign-${props.verticalAlign}`);
  if (props.headerColumn) cellClasses.push('table__cell--header');
  if (props.cellAlign)
    cellContentClasses.push(`d-flex justify-${props.cellAlign}`);

  const accessNestedKey = (obj: any, key: string) => {
    if (!key) return obj;
    return key.split('.').reduce((o, k) => o?.[k], obj);
  };

  const row = props.row;
  const fromKey = props.fromKey;
  const column = accessNestedKey(row, fromKey);
  const content = props.render ? props.render(column, row) : column;

  return (
    <td className={cellClasses.join(' ')}>
      {(props.container && (
        <div className={cellContentClasses.join(' ')}>{content || '-'}</div>
      )) ||
        content ||
        '-'}
    </td>
  );
}
